module.exports = __webpack_public_path__ + "img/seven-day-summary.4d156592.svg";